import { computed, unref, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";
import type { SequenceEnrollment } from "@/dtos/Sequence.dto";

export function useContactEnrollments(contactId: Ref<string | null | undefined> | string | null) {
  return useQuery({
    queryKey: computed(() => ["contactEnrollments", unref(contactId) || "none"]),
    enabled: computed(() => !!unref(contactId)),
    queryFn: async (): Promise<SequenceEnrollment[]> => {
      const result = await Contact.getContactEnrollments(unref(contactId) as string);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to load sequence enrollments");
      }
      return result.data.data;
    },
  });
}
